export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "primary",
        text: "HOME",
      },
    },
    {
      name: "Map Overview",
      url: "/base/Map",
      icon: "icon-map",
    },
    {
      name: "Overall Data",
      url: "/base/overall",
      icon: "icon-layers",
    },
    {
      name: "Backlog By Location",
      url: "/base/backlog-by-location",
      icon: "icon-layers",
    },
    {
      title: true,
      name: "TECHNICAL STATISTICS",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Active Backlog",
      url: "/activeBacklog",
      icon: "icon-chart",
    },
    {
      name: "Analytics By Model",
      url: "/analyticsByModel",
      icon: "icon-chart",
    },
    {
      name: "Received Equipment",
      url: "/ReceivedEquipment",
      icon: "icon-chart",
    },
    {
      name: "Recycled",
      url: "/base/recycled",
      icon: "icon-chart",
    },
    {
      name: "Tested",
      url: "/base/tested",
      icon: "icon-chart",
    },
    {
      name: "Warranty Repair",
      url: "/base/WarrantyRepair",
      icon: "icon-chart",
    },
    {
      name: "Arrival Date On Dock",
      url: "/base/ArrivalDate",
      icon: "icon-chart",
    },
    {
      name: "Inventory Status",
      url: "/base/InventoryStatus",
      icon: "icon-chart",
    },
    // {
    //   name: "Under Warranty",
    //   url: "/base/WAR",
    //   icon: "icon-chart",
    // },
    {
      title: true,
      name: "ACCOUNT",
      class: "",
      wrapper: {
        element: "",
        attributes: {},
      },
    },
    {
      name: "Inbox",
      url: "/base/inbox",
      icon: "icon-envelope",
    },
    // {
    //   title: true,
    //   name: "Issues",
    //   class: "",
    //   wrapper: {
    //     element: "",
    //     attributes: {}
    //   }
    // },
    // {
    //   name: "Issues Preview",
    //   url: "/base/IssuesPreview",
    //   icon: "icon-pencil"
    // },
    // {
    //   name: "Issues Map Overview",
    //   url: "/base/IssuesMap",
    //   icon: "icon-map"
    // }
  ],
};
